import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calculator as CalcIcon, History, Save, Settings } from 'lucide-react';
import { toast } from 'sonner';
import NotificationBell from '@/components/NotificationBell';

export default function CalculatorHeader({
  selectedProposalId,
  profitabilityResult,
  calculating,
  onSaveToProposal,
  onReloadData,
  onCalculate
}) {
  const navigate = useNavigate();

  const handleReloadData = () => {
    onReloadData();
    toast.success('📥 Reference data reloaded');
  };

  return (
    <header className="glass-card sticky top-0 z-50 shadow-lg border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate(-1)}
              className="p-2 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded-xl transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div className="flex items-center space-x-3">
              <div className="p-2.5 bg-primary/10 rounded-2xl">
                <CalcIcon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-slate-900 text-heading-tight">Pricing Calculator</h1>
                <p className="text-sm text-slate-500 font-medium">Revenue Inputs - Control Panel</p>
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <button 
              onClick={() => navigate('/calculation-history')}
              className="px-4 py-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-full transition-all text-sm font-medium text-slate-700 flex items-center gap-2"
              title="View calculation history"
            >
              <History className="w-4 h-4" />
              History
            </button>
            {selectedProposalId && profitabilityResult && (
              <button 
                onClick={onSaveToProposal}
                className="px-4 py-2 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded-full transition-all text-sm font-medium text-emerald-700 flex items-center gap-2"
                title="Save current calculation to selected proposal"
              >
                <Save className="w-4 h-4" />
                Save
              </button>
            )}
            <button 
              onClick={handleReloadData}
              className="p-2.5 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-xl transition-all"
              title="Reload reference data"
            >
              <Settings className="w-5 h-5" />
            </button>
            <NotificationBell />
            <button
              onClick={onCalculate}
              disabled={calculating}
              className="px-6 py-2.5 bg-primary text-white rounded-full hover:bg-indigo-700 transition-all hover:-translate-y-0.5 shadow-lg shadow-primary/20 text-sm font-semibold flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            >
              <CalcIcon className="w-4 h-4" />
              {calculating ? 'Calculating...' : 'Calculate'}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
